import { useEffect, useRef } from 'react';
import { constSelector, useRecoilState, useRecoilValue } from 'recoil';
import { useCherreValue } from '@cherre-frontend/data-fetching';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { getOrganizationPropertyModel } from 'src/products/data-submission-portal/recoil/getOrganizationPropertyModel';
import {
  activeCustomPropertyAttributesSelector,
  customPropertyAttributesAtom,
} from '../recoil/customPropertyAttributes';
import { getPropertyTypeCustomAttributes } from '../Panels/PropertiesPanel/queries/getPropertyTypeCustomAttributes';

export const useCustomPropertyAttributes = () => {
  return useRecoilState(customPropertyAttributesAtom);
};

export const useActiveCustomPropertyAttributes = () => {
  return useRecoilValue(activeCustomPropertyAttributesSelector);
};

export const useFetchAndSetCustomPropertyAttributes = () => {
  const valueWasSet = useRef(false);
  const propertyModel = useCherreValue(getOrganizationPropertyModel());
  const customAttributesFlag = useFeatureFlag('DspCustomPropertyAttributes');
  const isCustomAttributesAvailable =
    propertyModel?.isManyToOne && customAttributesFlag;

  const [customAttributesValue, setCustomAttributesValue] =
    useCustomPropertyAttributes();

  const shouldFetch = isCustomAttributesAvailable && !customAttributesValue;
  const response = useCherreValue(
    shouldFetch ? getPropertyTypeCustomAttributes() : constSelector(undefined)
  );

  useEffect(() => {
    if (response && !valueWasSet.current) {
      setCustomAttributesValue(response);
      valueWasSet.current = true;
    }
  }, [response, setCustomAttributesValue]);

  return [customAttributesValue, setCustomAttributesValue] as const;
};
